const LocationMarker = ({
  children,
}: {
  lat: number | undefined;
  lng: number | undefined;
  children: React.ReactChild;
}) => {
  return <>{children}</>;
};

export default LocationMarker;
